<section *ngIf="isShow" class="offline-container w-100 h-100 flex flex-column justify-content-center align-items-center gap-40" role="alert" aria-live="assertive" aria-labelledby="offline-title" aria-describedby="offline-description">
  <img class="octavio-image floating" [src]="octavioSadVersionImage" alt="" aria-hidden="true" />
  <div class="offline-messages flex flex-column justify-content-center align-items-center gap-16" id="offline-description">
    <h1 id="offline-title" class="visually-hidden">Sistema temporariamente indisponível</h1>
    <p>Nossos servidores estão temporariamente indisponíveis.</p>
    <p>Já estamos trabalhando na <b>solução!</b></p>
    <button *ngIf="(connectionState$ | async) === true" type="button" class="offline-infrastructure-link font-sm-semi cursor-pointer" (click)="openInfrastructureModal()">Ver estado da infraestrutura</button>
  </div>
  <app-branding [variant]="brandingVariant.WHITE"></app-branding>
</section>

<app-dialog title="Estado da infraestrutura" [showDialog]="showInfrastructureModal" (hideDialog)="closeInfrastructureModal()" [size]="dialogSize.MEDIUM" [showConfirmButton]="false" [hasFooter]="true">
  <app-health-status-widget></app-health-status-widget>
</app-dialog>
